module.exports = __webpack_public_path__ + "static/img/5.cf7906c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/5.png
// module id = ML1y
// module chunks = 0